// extracted by mini-css-extract-plugin
export default {"cls1":"Timer-cls1___1f9d8192607354c79c2","cls2":"Timer-cls2___95f4b669d64cf62b5be Timer-cls1___1f9d8192607354c79c2","darkDigits":"Timer-darkDigits___4dbfede1b6b7f54f2a1"};